:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pr-t-space-lar102228{padding-right:var(--t-space-larger);}
:root ._pl-t-space-lar102228{padding-left:var(--t-space-larger);}
@media (min-width: 601px){:root:root:root:root:root ._pr-_gtSm_0px{padding-right:0px;}}
@media (min-width: 601px){:root:root:root:root:root ._pl-_gtSm_0px{padding-left:0px;}}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._items-center{align-items:center;}